export class AutopaySettings {
	enableAutopay: boolean;
	maxFutureStartDateInDays: number;
	numberofRetriesForCardDeclines: number;
	payInFullOnly: boolean;
	portfolioKey: number;
	autopayPaymentOptions: Array<AutopayPaymentOptions>;
}

export class AutopayPaymentOptions {
	autopayRuleType: number;
	autopayRuleValue: number;
	portfolioKey: number;
}

export class AutopayFrequencyOption {
	autopayTriggerType: number;
	value: number;
	description: string;
	planType: number;
}
